import { createSignal } from "solid-js";

// True while the project-home name/description form has unsaved edits.
const [projectDetailsDirty, setProjectDetailsDirty] = createSignal(false);

const [pendingProjectAction, setPendingProjectAction] = createSignal<(() => void) | null>(null);

export { setProjectDetailsDirty, pendingProjectAction };

export const clearPendingProjectAction = () => setPendingProjectAction(null);

/**
 * Intercepts an action that would leave project-details edit mode. Returns
 * true when it captured the action for the save-reminder dialog to run after
 * Save/Discard — the caller must abort in that case. Returns false when there
 * are no unsaved edits, so the caller runs its action normally.
 */
export function guardUnsavedProjectDetails(proceed: () => void): boolean {
  if (!projectDetailsDirty()) return false;
  setPendingProjectAction(() => proceed);
  return true;
}
